import Vue from 'vue';
import VueRouter from 'vue-router';

import MapView from '@/js/views/map';
import MapList from '@/js/views/list';
import MapAdmin from '@/js/views/admin';
//import AppCode from '@/js/views/appcode';

Vue.use(VueRouter);
const router = new VueRouter({
    mode: 'history',
    routes:[
        {
            path: '/map/admin',
            name: 'admin',
            components: {
                default:MapAdmin,
            },
        },
        {
            path: '/map/overview/:map_id',
            name: 'map',
            components:{
                default:MapView,

            }
        },
        {
            path: '/map/block/:map_id/:block_id',
            name: 'block',
            components: {
                default:MapView,
            },
        },
        {
            path: '/map',
            name: 'list',
            components: {
                default:MapList,
            },
        },

    ]
});

export default router;
